// @flow
import React, { Component } from 'react';
import { Segment, Grid, Form, Header, Table, Dropdown, Popup, Label, Icon } from 'semantic-grab-ui/src';
import { Row, Select, Col } from 'grab-ui';
import _ from 'lodash';

import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import { treatmentActionConstraints, getActionFormConstraints } from './constraints';
import { SubActionForm } from 'components/form/trident-campaigns';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import { nodeTypes } from 'data/trident-types';
import LimitsTable from './LimitsTable';
import './TreatmentForm.scss';
import { getActionsList } from './util';
import { VARIABLE_NAME, DYNAMIC_TRACK } from './constants/campaign';

interface Props {
  model: TridentCampaignDetails;
  canActivate: boolean;
  currentNode: string;
  parentNode: string;
  parentKeyList: Array<string>;
  onModelChange: (_?: object) => void;
  handleInputChange: Function;
  handleControlBlur: Function;
  handleCloseModal: Function;
  isAdd: boolean;
  handleDeleteNode: Function;
  listRuleTypes: object;
  eventType: string;
}

@formComponent(treatmentActionConstraints)
export default class ActionForm extends Component<Props> {
  handleAddSubAction = (event: any, data: any) => {
    const actionType = data.value;
    const updatedModel = _.cloneDeep(this.props.model);
    let newAction: any = {
      type: actionType,
      meta: {},
    };
    if (actionType === 'awardReward' || actionType === 'bulkAwardReward') {
      newAction = { ...newAction, isValid: false };
    }
    if (actionType === 'sendEmail' || actionType === 'bulkSendEmail' || actionType === 'bulkSendEmailByAddress') {
      newAction = { ...newAction, replyToEmail: true };
    }
    const actionList = _.get(updatedModel.nodes[this.props.currentNode], 'data', []);
    actionList.push(newAction);
    _.set(updatedModel.nodes[this.props.currentNode], 'data', actionList);
    this.props.onModelChange(updatedModel);
  }

  trackingVariablesChange = (value: any) => {
    const { currentNode, onModelChange } = this.props;
    const updatedModel = _.cloneDeep(this.props.model);

    updatedModel.nodes[currentNode] = { ...updatedModel.nodes[currentNode], [DYNAMIC_TRACK]: value };
    onModelChange(updatedModel);
  }

  // code to render dropdown of all possible actions for event type
  renderNewActionDropdown = () => {
    const actionTypeOptions = getActionsList(this.props);

    const rootActionOptions = actionTypeOptions.filter(a => a.group === '');
    const actionGroups = _.groupBy(actionTypeOptions.filter(a => a.group !== ''), 'group');

    const renderActionItem = (actionTypeData: any) => (
      <Dropdown.Item
        key={actionTypeData.type}
        value={actionTypeData.type}
        onClick={this.handleAddSubAction}
      >
        {`${actionTypeData.noun} `}
        {actionTypeData.description && <Popup
          trigger={<Icon name="info circle" />}
          content={actionTypeData.description}
          size="mini"
        />}
      </Dropdown.Item>
    );
    return (
      <Dropdown className="rule-menu" text="Add Action" simple>
        <Dropdown.Menu className="right">
          {_.map(actionGroups, (val, key) => (
            <Dropdown.Item key={key}>
              <Icon name="triangle right" />
              <span className="text">{key}</span>
              <Dropdown.Menu className="right">
                {_.map(val, renderActionItem)}
              </Dropdown.Menu>
            </Dropdown.Item>
          ))}
          {_.map(rootActionOptions, renderActionItem)}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  render() {
    const { model, currentNode, parentKeyList, parentNode, listRuleTypes } = this.props;
    const actionFormConstraints = getActionFormConstraints(currentNode);
    const targetUserType = _.get(model, 'targetUserType', '');
    const treatmentStartNode = _.get(model, `nodes[${parentKeyList[0]}]`, {});
    const eventTypes = _.map(_.get(treatmentStartNode, 'data.scenarios'), (scenario: any) => (scenario.eventType));

    let eventTypeData = null;
    eventTypes.forEach(eventType => {
      const data = _.find(_.get(listRuleTypes, targetUserType, []), { eventType });
      if (data) {
        eventTypeData = data;
      }
    });

    const limits = _.get(eventTypeData, 'limit', []);
    const parentNodeType = _.get(model, `nodes[${parentNode}].type`);
    const rootNodeLimits = _.get(model, `nodes[${parentKeyList[0]}].limits`, []);
    const treatmentStartNodeType = _.get(model, `nodes[${parentKeyList[0]}].type`);
    const needLimit =
      treatmentStartNodeType !== nodeTypes.schedule &&
      parentNodeType !== nodeTypes.time;

    const freezeSubActions = parentNodeType === nodeTypes.randomizer; // no create or delete of subactions

    const limitVarOptions = _.get(eventTypeData, 'limitVars', []).map((x: any) => {
      return {
        text: x.noun,
        value: x[VARIABLE_NAME],
      };
    });

    let defaultLimitVars = [];
    if (model.nodes[currentNode][DYNAMIC_TRACK] === undefined) {
      defaultLimitVars = limitVarOptions.map((item: any) => item.value);
      this.trackingVariablesChange(defaultLimitVars);
    }

    const isAfterCount = ['count', 'countCondition'].includes(parentNodeType);
    const isEnableDynamicVariables = rootNodeLimits.some(x => Object.keys(x).includes(VARIABLE_NAME)) && !isAfterCount;
    const isParentNodeMultipleScenarios = parentNodeType === nodeTypes.scenarios && _.get(model, `nodes[${parentNode}].data.scenarios`, []).length > 1;

    return (
      <div className="treatment-form">
        <Segment className="treatment-form-segment">
          <Grid columns="equal">
            <Grid.Column width={12}>
              <Header as="h3">Action Name</Header>
            </Grid.Column>
          </Grid>
          <Grid columns="equal">
            <Grid.Column width={12}>
              <Form>
                <Grid>
                  <Grid.Column width={12}>
                    <FormInputWithError
                      name={'nodes.'.concat(`${currentNode}`, '.name')}
                      {...this.props}
                    >
                      <Form.Input
                        required
                        value={model.nodes[currentNode].name}
                        onChange={this.props.handleInputChange}
                        onBlur={this.props.handleControlBlur}
                      />
                    </FormInputWithError>
                  </Grid.Column>
                </Grid>
              </Form>
            </Grid.Column>
          </Grid>
          {/* Usage */}
          {!this.props.isAdd &&
            <div>
              <Grid columns="equal">
                <Grid.Column width={12}>
                  <Header as="h3">Usage</Header>
                </Grid.Column>
              </Grid>
              <Grid>
                <Grid.Column width={16}>
                  <Table striped>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>
                          <span>Action usage today</span>
                        </Table.Cell>
                        <Table.Cell>
                          <span>{`${_.get(model, `usage.actionUsages[${currentNode}].daily`, 0)}`}</span>
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <span>Action usage total</span>
                        </Table.Cell>
                        <Table.Cell>
                          <span>{`${_.get(model, `usage.actionUsages[${currentNode}].total`, 0)}`}</span>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid>
            </div>
          }
          {/* Limit */}
          {needLimit &&
            <div>
              <Grid columns="equal">
                <Grid.Column width={12}>
                  <Header as="h3">Limits</Header>
                </Grid.Column>
              </Grid>
              <Grid columns="equal">
                <Grid.Column width={16}>
                  <LimitsTable
                    {...this.props}
                    pageName="Action"
                    className="action-details"
                    limits={limits}
                    eventTypes={_.get(eventTypeData, 'eventType', '') ? [_.get(eventTypeData, 'eventType', '')] : []}
                    node={{}}
                    handleLimitChange={() => {}}
                  />
                  {
                    isParentNodeMultipleScenarios &&
                    <p>
                      <b>Note: The limits here will apply to each scenario in the scenarios node.</b>
                      <Popup content="Example: if you have 2 scenarios in the scenarios node, and you set total limit here to 10, then this action can be triggered maximum 20 times" trigger={<Icon name="info circle" />} />
                    </p>
                  }
                </Grid.Column>
              </Grid>
              {isEnableDynamicVariables && limitVarOptions.length > 0 && (<Grid columns="equal">
                <Grid.Column>
                  <Row>
                    <Col span={4}>Tracking variables</Col>
                    <Col span={5}>
                      {/* @ts-ignore */}
                      <Select value={model.nodes[currentNode][DYNAMIC_TRACK] || defaultLimitVars} onChange={this.trackingVariablesChange} mode="tags" placeholder="Select variables" style={{ width: '100%', marginLeft: 20 }}>
                        {limitVarOptions.map((item: any) => <Select.Option value={item.value}>{item.text}</Select.Option>)}
                      </Select></Col>
                  </Row>

                </Grid.Column>
              </Grid>)}
            </div>
          }
        </Segment>
        <Segment className="treatment-form-segment">
          <Grid>
            <Grid.Column width={12}>
              <Label
                size="medium"
                color="green"
              >
                Sub-Actions
              </Label>
              {!freezeSubActions && this.renderNewActionDropdown()}
            </Grid.Column>
          </Grid>
          <br />
          <SubActionForm
            onModelChange={this.props.onModelChange}
            model={this.props.model}
            canActivate={this.props.canActivate}
            currentNode={currentNode}
            parentNode={parentNode}
            parentKeyList={this.props.parentKeyList}
            handleCloseModal={this.props.handleCloseModal}
            isAdd={this.props.isAdd}
            handleDeleteNode={this.props.handleDeleteNode}
            constraints={actionFormConstraints}
            listRuleTypes={listRuleTypes}
            enableDynamicPoint={!isAfterCount}
            eventType={_.get(eventTypeData, 'eventType', '')}
            freezeSubActions={freezeSubActions}
          />
        </Segment>
      </div>
    );
  }
}
